import { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const IssueOpenIcon = () => (
  <svg aria-hidden="true" height="16" viewBox="0 0 16 16" width="16" style={{ fill: "var(--gh-green)" }}>
    <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Z" />
  </svg>
);

const contactLinks = [
  {
    label: "Email",
    value: "akanshabharti1213@gmail.com",
    href: "mailto:akanshabharti1213@gmail.com",
    icon: (
      <svg aria-hidden="true" height="20" viewBox="0 0 16 16" width="20" style={{ fill: "currentColor" }}>
        <path d="M1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25v-8.5C0 2.784.784 2 1.75 2ZM1.5 12.251c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V5.809L8.38 9.397a.75.75 0 0 1-.761 0L1.5 5.809v6.442Zm13-8.181v-.32a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v.32L8 7.88Z" />
      </svg>
    ),
  },
  {
    label: "LinkedIn",
    value: "akansha-bharti",
    href: "https://www.linkedin.com/in/akansha-bharti/",
    icon: (
      <svg viewBox="0 0 24 24" height="20" width="20" style={{ fill: "#0a66c2" }}>
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    label: "GitHub",
    value: "akanshaBharti",
    href: "https://github.com/akanshaBharti",
    icon: (
      <svg aria-hidden="true" height="20" viewBox="0 0 16 16" width="20" style={{ fill: "currentColor" }}>
        <path d="M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z" />
      </svg>
    ),
  },
  {
    label: "Twitter",
    value: "@Akansha_1213",
    href: "https://twitter.com/Akansha_1213",
    icon: (
      <svg aria-hidden="true" height="20" viewBox="0 0 16 16" width="20" style={{ fill: "currentColor" }}>
        <path d="M9.294 7.23 13.99 1.5h-1.118L8.783 6.463 5.57 1.5H1.8l4.94 7.19L1.8 14.5h1.118l4.319-5.206 3.45 5.206H14.2L9.293 7.23Zm-1.53 1.844-.5-.716L3.332 2.353h1.714l3.213 4.598.5.716 4.177 5.98h-1.714L7.764 9.074Z" />
      </svg>
    ),
  },
];

const Contact = () => {
  const form = useRef();
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [issueNum] = useState(() => Math.floor(Math.random() * 90) + 10);

  const validateEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!name) newErrors.name = "Name is required";
    if (!contact) newErrors.contact = "Contact is required";
    if (!email) newErrors.email = "Email is required";
    else if (!validateEmail(email)) newErrors.email = "Email is invalid";
    if (!message) newErrors.message = "Message is required";
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setIsSubmitting(true);
      emailjs
        .sendForm("service_mkmmv7h", "template_wbly34v", form.current, "DI_HBtf80DLmjRnyD")
        .then(() => {
          toast.success("Issue submitted! I'll respond within 24 hours.");
          setSubmitted(true);
          setName(""); setContact(""); setEmail(""); setMessage(""); setErrors({});
        }, () => {
          toast.error("Failed to submit. Please try again.");
        })
        .finally(() => setIsSubmitting(false));
    }
  };

  return (
    <div>
      <ToastContainer theme="dark" position="top-right" />

      {/* Page header */}
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, color: "var(--gh-text)", marginBottom: 4 }}>Contact</h2>
        <p style={{ fontSize: 14, color: "var(--gh-text-secondary)" }}>
          Get in touch — I typically respond within 24 hours.
        </p>
      </div>

      {/* Tabs bar */}
      <div style={{ display: "flex", alignItems: "center", gap: 0, borderBottom: "1px solid var(--gh-border)", marginBottom: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", fontSize: 14, fontWeight: 600, color: "var(--gh-text)", borderBottom: "2px solid var(--gh-accent)", marginBottom: -1 }}>
          <IssueOpenIcon />
          {submitted ? "Replied" : "New Message"}
        </div>
      </div>

      <div className="contact-grid" style={{ display: "grid", gridTemplateColumns: "1fr 280px", gap: 20, alignItems: "flex-start", marginTop: 20 }}>
        {/* Issue form */}
        <div style={{ border: "1px solid var(--gh-border)", borderRadius: 6, overflow: "hidden" }}>

          {/* Issue row */}
          <div style={{ padding: "12px 16px", borderBottom: "1px solid var(--gh-border)", display: "flex", alignItems: "center", gap: 10 }}>
            <IssueOpenIcon />
            <span style={{ fontSize: 15, fontWeight: 600, color: "var(--gh-link)" }}>
              Say hello or propose a collaboration
            </span>
            <span style={{ marginLeft: "auto", fontSize: 12, color: "var(--gh-text-secondary)" }}>
              #{issueNum}
            </span>
          </div>

          {/* New issue form */}
          <div style={{ padding: 20 }}>
            <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
              {/* Avatar */}
              <div style={{
                width: 40, height: 40, borderRadius: "50%",
                background: "linear-gradient(135deg, #1f6feb, var(--gh-purple))",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 14, fontWeight: 700, color: "white", flexShrink: 0,
              }}>
                ?
              </div>

              {/* Form */}
              <form ref={form} onSubmit={handleSubmit} style={{ flex: 1 }}>
                <div style={{ border: "1px solid var(--gh-border)", borderRadius: 6, overflow: "hidden" }}>
                  {/* Form header tabs */}
                  <div style={{ padding: "8px 12px", background: "var(--gh-card)", borderBottom: "1px solid var(--gh-border)", display: "flex", gap: 8 }}>
                    <span style={{ fontSize: 13, color: "var(--gh-text)", borderBottom: "2px solid var(--gh-accent)", padding: "4px 8px" }}>Write</span>
                    <span style={{ fontSize: 13, color: "var(--gh-text-secondary)", padding: "4px 8px" }}>Preview</span>
                  </div>

                  <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 12 }}>
                    {/* Name + Contact row */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                      <div>
                        <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "var(--gh-text-secondary)", marginBottom: 4 }}>
                          Your Name <span style={{ color: "var(--gh-red)" }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          value={name}
                          onChange={e => setName(e.target.value)}
                          className="gh-input"
                          placeholder="John Recruiter"
                          style={{ height: 32 }}
                        />
                        {errors.name && <p style={{ color: "var(--gh-red)", fontSize: 12, marginTop: 4 }}>{errors.name}</p>}
                      </div>
                      <div>
                        <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "var(--gh-text-secondary)", marginBottom: 4 }}>
                          Contact Number <span style={{ color: "var(--gh-red)" }}>*</span>
                        </label>
                        <input
                          type="tel"
                          name="contact"
                          value={contact}
                          onChange={e => setContact(e.target.value)}
                          className="gh-input"
                          placeholder="+91 98765 43210"
                          style={{ height: 32 }}
                        />
                        {errors.contact && <p style={{ color: "var(--gh-red)", fontSize: 12, marginTop: 4 }}>{errors.contact}</p>}
                      </div>
                    </div>

                    {/* Email */}
                    <div>
                      <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "var(--gh-text-secondary)", marginBottom: 4 }}>
                        Email Address <span style={{ color: "var(--gh-red)" }}>*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        className="gh-input"
                        placeholder="recruiter@company.com"
                        style={{ height: 32 }}
                      />
                      {errors.email && <p style={{ color: "var(--gh-red)", fontSize: 12, marginTop: 4 }}>{errors.email}</p>}
                    </div>

                    {/* Message */}
                    <div>
                      <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "var(--gh-text-secondary)", marginBottom: 4 }}>
                        Message / Issue Description <span style={{ color: "var(--gh-red)" }}>*</span>
                      </label>
                      <textarea
                        name="message"
                        value={message}
                        onChange={e => setMessage(e.target.value)}
                        className="gh-textarea"
                        placeholder="Hi Akansha! I came across your portfolio and ..."
                        rows={6}
                      />
                      {errors.message && <p style={{ color: "var(--gh-red)", fontSize: 12, marginTop: 4 }}>{errors.message}</p>}
                    </div>
                  </div>

                  {/* Form footer */}
                  <div style={{ padding: "12px 16px", background: "var(--gh-card)", borderTop: "1px solid var(--gh-border)", display: "flex", justifyContent: "flex-end" }}>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn-gh-green"
                      style={{ opacity: isSubmitting ? 0.7 : 1, cursor: isSubmitting ? "not-allowed" : "pointer" }}
                    >
                      {isSubmitting ? (
                        <>
                          <div style={{ width: 14, height: 14, border: "2px solid white", borderTopColor: "transparent", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
                          Submitting...
                        </>
                      ) : (
                        <>
                          <IssueOpenIcon />
                          Submit new issue
                        </>
                      )}
                    </button>
                  </div>
                </div>

                {submitted && (
                  <div style={{
                    marginTop: 16, padding: 16, borderRadius: 6,
                    background: "rgba(63,185,80,0.1)", border: "1px solid rgba(63,185,80,0.4)",
                    display: "flex", alignItems: "center", gap: 10,
                  }}>
                    <svg height="20" viewBox="0 0 16 16" width="20" style={{ fill: "var(--gh-green)" }}>
                      <path d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z" />
                    </svg>
                    <span style={{ color: "var(--gh-green)", fontSize: 14, fontWeight: 600 }}>
                      Issue submitted successfully! I'll respond within 24 hours.
                    </span>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>

        {/* Sidebar: contact info + availability */}
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

          {/* Labels / Contact links */}
          <div style={{ background: "var(--gh-surface)", border: "1px solid var(--gh-border)", borderRadius: 6, overflow: "hidden" }}>
            <div style={{ padding: "10px 16px", background: "var(--gh-card)", borderBottom: "1px solid var(--gh-border)" }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: "var(--gh-text)" }}>Labels</span>
            </div>
            <div style={{ padding: 12 }}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 12 }}>
                {["full-stack-developer", "react", "python", "django", "available-for-hire", "remote-ok"].map(l => (
                  <span key={l} className="gh-topic" style={{ fontSize: 11 }}>{l}</span>
                ))}
              </div>
              <div style={{ fontSize: 12, color: "var(--gh-text-secondary)", borderTop: "1px solid var(--gh-border)", paddingTop: 12 }}>
                <p style={{ marginBottom: 6 }}>Links to reach me:</p>
                {contactLinks.map(link => (
                  <a
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex", alignItems: "center", gap: 8,
                      padding: "6px 0", color: "var(--gh-text-secondary)", textDecoration: "none",
                      borderBottom: "1px solid var(--gh-card)", fontSize: 13,
                      transition: "color 0.15s",
                    }}
                    onMouseEnter={e => e.currentTarget.style.color = "var(--gh-link)"}
                    onMouseLeave={e => e.currentTarget.style.color = "var(--gh-text-secondary)"}
                  >
                    {link.icon}
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {link.value}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Availability */}
          <div style={{ background: "var(--gh-surface)", border: "1px solid var(--gh-border)", borderRadius: 6, overflow: "hidden" }}>
            <div style={{ padding: "10px 16px", background: "var(--gh-card)", borderBottom: "1px solid var(--gh-border)" }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: "var(--gh-text)" }}>Availability</span>
            </div>
            <div style={{ padding: 16 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                <span style={{ width: 10, height: 10, borderRadius: "50%", background: "var(--gh-green)", display: "inline-block", animation: "pulseGreen 2s infinite" }} />
                <span style={{ fontSize: 14, fontWeight: 600, color: "var(--gh-green)" }}>Available for work</span>
              </div>
              <ul style={{ listStyle: "none", padding: 0, fontSize: 13, color: "var(--gh-text-secondary)" }}>
                {[
                  "📍 Based in Delhi, India",
                  "🌍 Open to remote opportunities",
                  "✈️ Open to relocation",
                  "💼 Full Stack Developer roles",
                  "🐍 Backend stack: Python, Django",
                  "⚡ 24h average response",
                ].map((item, i) => (
                  <li key={i} style={{ marginBottom: 6 }}>{item}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* Response time */}
          <div style={{
            background: "var(--gh-surface)", border: "1px solid var(--gh-border)", borderRadius: 6,
            padding: 16, textAlign: "center",
          }}>
            <div style={{ fontSize: 36, fontWeight: 700, color: "var(--gh-link)" }}>24h</div>
            <div style={{ fontSize: 13, color: "var(--gh-text-secondary)" }}>Average response time</div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (max-width: 720px) {
          .contact-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
};

export default Contact;
